import type { HandleAction, HandleDefinition } from '../../widgets/types';

export function pruneHandleActions(
  handleActions: Record<string, HandleAction> | undefined,
  outputs: HandleDefinition[] | undefined,
) {
  if (!handleActions || !outputs) return { handleActions, changed: 0 };

  const ids = new Set(outputs.map((h) => h.id));
  const kept = Object.entries(handleActions).filter(([id]) => ids.has(id));

  const changed = Object.keys(handleActions).length - kept.length;
  if (changed === 0) return { handleActions, changed };

  return { handleActions: kept.length > 0 ? Object.fromEntries(kept) : undefined, changed };
}
